import { useRef, useState, type MutableRefObject } from 'react';

// Håller ihop de tre flaggorna som markerar att en tur pågår. Glider de isär —
// typiskt isStreaming nollställd men inFlight kvar — låser sig chatten i "skickar"
// tills sidan laddas om, och ingenting i gränssnittet avslöjar varför.
export const useTurnLifecycle = ({
  beginStream,
  endStream,
  focusRef,
}: {
  beginStream: () => void;
  endStream: () => void;
  focusRef: MutableRefObject<HTMLTextAreaElement | null>;
}) => {
  const [isStreaming, setIsStreaming] = useState(false);
  const inFlightRef = useRef(false);

  const isTurnInFlight = () => inFlightRef.current;

  const startTurn = () => {
    inFlightRef.current = true;
    setIsStreaming(true);
    beginStream();
  };

  const finishTurn = ({ refocus }: { refocus: boolean }) => {
    inFlightRef.current = false;
    setIsStreaming(false);
    endStream();
    if (refocus) {
      focusRef.current?.focus();
    }
  };

  return { isStreaming, isTurnInFlight, startTurn, finishTurn };
};
